import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { baseUrl } from "..";
import CountdownTimer from "../components/CountDownTimer";
import Frame from "../components/Frame";

const smartschoolMapping: Record<string, string> = {
  // "6d3f8f22-ac16-472e-83aa-410cb23d814a":
  "596b76e3-5cdc-42d6-b908-39de5c8764a7":
    "https://sgr12adite.smartschool.be/login/sso/init/office365",
  "400f4499-88da-46e6-823c-fa3252c1d1fb":
    "https://bsdeklimop.smartschool.be/login/sso/init/office365",
  "3bf2a105-1190-4f2f-8d18-03c5cfcc6093":
    "https://bsdeletterberg.smartschool.be/login/sso/init/office365",
  "77dbab95-7b9b-4747-8d57-e79801fe5a99":
    "https://bsdeberk.smartschool.be/login/sso/init/office365",
  "f1ad9e12-8d6e-4887-b546-6155d15b321e":
    "https://freinetschooldepit.smartschool.be/login/sso/init/office365",
  "aabebc78-923a-4348-ba93-0a5572d3264c":
    "https://bstdorp.smartschool.be/login/sso/init/office365",
  "b8f99bd9-0814-45dc-a885-1dbcf4156518":
    "https://dekleineprinsdiest.smartschool.be/login/sso/init/office365",
  "a202d407-8d91-45a0-960b-d1f706aae0f5":
    "https://bsdehoogvlieger.smartschool.be/login/sso/init/office365",
  "b6cc77b8-270e-436f-ac6c-2fd31367f1f2":
    "https://bszonnedorp.smartschool.be/login/sso/init/office365",
  "d3315f07-22fc-4a4f-b95d-b71701dceff2":
    "https://bsdewinge.smartschool.be/login/sso/init/office365",
  "17e89d64-a1ae-42d5-8e7a-142c4b3d19d5":
    "https://russelberg.smartschool.be/login/sso/init/office365",
  "587cccb4-5f79-4d13-aacc-378780e74e0c":
    "https://deprinsdiest.smartschool.be/login/sso/init/office365",
  "f0b168c1-09df-44ef-a095-42b1bd2fbfdb":
    "https://site-a.smartschool.be/login/sso/init/office365",
  "c40709b0-e474-4e60-a4d3-12320476cdf6":
    "https://gbsbegijnendijk.smartschool.be",
  "f80f7278-a72f-452e-9450-cc2019528a78": "https://gbsbetekom.smartschool.be",
};

const hoverColors = [
  "hover:bg-adite-300",
  "hover:bg-adite-200",
  "hover:bg-adite-100",
  "hover:bg-adite-400",
];
const colors = ["bg-adite-400", "bg-adite-300", "bg-adite-200", "bg-adite-100"];

const App: React.FC = () => {
  const { instance, accounts } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);
  const [smartschools, setSmartschools] = useState<string[]>([]);
  const [buttons, setButtons] = useState<any>([]);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await instance.initialize(); // Ensure MSAL is initialized
        await instance.handleRedirectPromise(); // Handle redirect response
        setIsInitialized(true); // Mark initialization as complete
      } catch (error) {
        console.error("Error initializing MSAL", error);
      }
    };

    initializeMsal();
  }, []);

  useEffect(() => {
    if (isInitialized) {
      const getButtons = async () => {
        const response = await fetch(baseUrl + "/api/buttons?populate=*", {
          headers: {
            Authorization: `Bearer ${accounts[0].idToken}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);
        setButtons(data); // Adjust based on the structure of your API response
      };
      getButtons();
    }
  }, [isInitialized]);

  const [unreadCount, setUnreadCount] = useState(null);

  useEffect(() => {
    if (isInitialized) {
      const getUnreadCount = async () => {
        try {
          const response = await instance.acquireTokenSilent({
            scopes: ["Mail.Read"],
            account: accounts[0],
          });

          const accessToken = response.accessToken;

          const graphResponse = await fetch(
            "https://graph.microsoft.com/v1.0/me/mailFolders/inbox?$select=unreadItemCount",
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            },
          );

          if (!graphResponse.ok) {
            throw new Error("Graph API request failed");
          }

          const data = await graphResponse.json();
          console.log(data.unreadItemCount);
          setUnreadCount(data.unreadItemCount);
        } catch (err) {
          console.error(err);
        }
      };

      getUnreadCount();
    }
  }, [instance, isInitialized]);

  useEffect(() => {
    if (isInitialized) {
      if (accounts.length === 0) {
        instance.loginRedirect();
      } else {
        if (accounts[0].idTokenClaims !== undefined) {
          console.log(accounts);
          console.log(accounts[0].idTokenClaims["groups"] as string[]);
          const groups = accounts[0].idTokenClaims["groups"] as string[];
          let extractedUrls = groups
            .map((id) => smartschoolMapping[id])
            .filter((url) => url); // Filter out undefined (in case of invalid IDs)

          if (extractedUrls === undefined || extractedUrls.length === 0) {
            extractedUrls = [
              "https://sgr12adite.smartschool.be/login/sso/init/office365",
            ];
          }

          setSmartschools(extractedUrls); // Update the state
        }

        // const groups: string[] = accounts[0].idTokenClaims["groups"];
      }
    }
  }, [accounts, isInitialized]);

  const handleLogin = () => {
    instance.loginRedirect();
  };

  //   const handleLogout = () => {
  //     instance.logoutPopup().catch((error) => {
  //       console.error("Logout failed", error);
  //     });
  //   };

  if (accounts.length > 0) {
    return (
      <Frame>
        {/* Grid Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 w-full">
          {(buttons as any[]).map((item, index) => (
            <div
              key={index}
              className={`bg-white flex h-auto w-full ${
                index % 4 >= 2 ? "md:flex-row-reverse" : "md:flex-row"
              } ${index % 2 === 0 ? "flex-row-reverse" : ""}`}
            >
              {item.type === "placeholder" ? (
                (() => {
                  const title = item.title || "";
                  const isCounter =
                    title.startsWith("counter(") && title.endsWith(")");

                  if (isCounter) {
                    const counterContent = title.slice(8, -1); // remove 'counter(' and ')'
                    const [dateStr, label] = counterContent.split("|");
                    const countdownDate = dateStr?.trim();
                    const countdownText = label?.trim();

                    if (countdownDate && countdownText) {
                      return (
                        <div className="flex items-center justify-center w-full h-full">
                          <CountdownTimer
                            targetDate={countdownDate}
                            label={countdownText}
                            colors={colors}
                            index={index}
                            hoverColors={hoverColors}
                            backgroundImage={baseUrl + item.thumbnail.url}
                          />
                        </div>
                      );
                    }
                  }

                  // Fallback to normal image
                  return (
                    <img
                      src={baseUrl + item.thumbnail.url}
                      alt={`Image ${index + 1}`}
                      className="h-full w-full object-cover"
                    />
                  );
                })()
              ) : item.type === "link" ? (
                <a
                  className={
                    "flex items-center justify-center text-center w-full " +
                    colors[index % 4] +
                    " " +
                    hoverColors[index % 4]
                  }
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.thumbnail?.url ? (
                    <img
                      src={baseUrl + item.thumbnail.url}
                      alt={`Image ${index + 1}`}
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <div>
                      <h2 className="text-md text-white">{item.title}</h2>
                      {item.title === "MIJN MAILBOX" &&
                        unreadCount !== null && (
                          <p className="text-sm mt-1 text-white">
                            Ongelezen mails: {unreadCount}
                          </p>
                        )}
                    </div>
                  )}
                </a>
              ) : item.type === "powerapp" ? (
                <a
                  className={
                    "flex items-center justify-center text-center w-full " +
                    colors[index % 4] +
                    " " +
                    hoverColors[index % 4]
                  }
                  href={"/apps/" + item.appId + "?landscape=" + item.landscape}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h2 className="text-md text-white">{item.title}</h2>
                </a>
              ) : item.type === "smartschool" ? (
                <a
                  className={
                    "flex items-center justify-center text-center w-full " +
                    colors[index % 4] +
                    " " +
                    hoverColors[index % 4]
                  }
                  href={smartschools[0]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h2 className="text-md text-white">MIJN SMARTSCHOOL</h2>
                </a>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
      </Frame>
    );
  } else {
    // handleLogin();
    return (
      <div className="flex justify-center items-center h-96">
        <button
          onClick={handleLogin}
          className="btn btn-primary border p-4 text-white bg-slate-600"
        >
          Login with Azure AD
        </button>
      </div>
    );
  }
};

export default App;
